import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectTab } from '../../store/actions/index';
import { BodySmall, Heading5 } from './GlobalElements/Typography';
import { Card } from './GlobalElements/Card';
import { tokens } from '../../public/tokens';

const HomeTile = ({ to, tab, title, heading, description, icon, badge = 0 }) => {
    const dispatch = useDispatch();
    return (
        <li>
            <Card
                as={Link}
                padding={tokens.globals['spacing-lg']}
                to={to}
                className="home-link home-card-main"
                justifyContent="flex-start"
                onClick={() => dispatch(selectTab({ tab }))}
                title={title}
            >
                <div className="home-bx-card">
                    <div className="icon">
                        <i className={`fa-light fa-fw ${icon}`} aria-hidden="true"></i>
                        {badge > 0 && <small className="notification-bg">{badge > 9 ? '9+' : badge}</small>}
                    </div>
                    <div className="home-bx-card-info">
                        <Heading5>{heading}</Heading5>
                        <BodySmall>{description}</BodySmall>
                    </div>
                </div>
            </Card>
        </li>
    );
};

const HomeLinks = (props) => {
    const notificationcount = useSelector((state) => state.notification);
    const filesRequired = useSelector((state) => state.registrations.filesRequired);
    const examReg = localStorage.getItem('examReg');
    const reReg = localStorage.getItem('reReg');
    const ticketNotification = useSelector((state) => state.ticketNotification);
    const chatNotification = useSelector((state) => state.chatNotification);
    return (
        <>
            <ul className="card-grid home-ul-list list-unstyled">
                <HomeTile
                    to="/profile"
                    tab={2}
                    icon="fa-user"
                    title="Always keep your student profile information up to date"
                    heading="My Profile"
                    description="Always keep your student profile information up to date."
                />
                <HomeTile
                    to="/mycourses"
                    tab={4}
                    icon="fa-books"
                    title="All your important course information for easy study"
                    heading="My Courses"
                    description="All your important course information for easy study."
                    badge={chatNotification.chatnotificationcount.newsRoomUnreadMessageCount}
                />
                <HomeTile
                    to="/mytickets"
                    tab={5}
                    icon="fa-ticket-simple"
                    title="Log and track your tickets with the support team"
                    heading="My Tickets"
                    description="Log and track your tickets with the support team."
                    badge={ticketNotification.ticketnotificationcount}
                />
                <HomeTile
                    to="/mynotifications"
                    tab={6}
                    icon="fa-bell"
                    title="Get important information of direct interest to you and your studies"
                    heading="Notifications"
                    description="Get important information of direct interest to you and your studies."
                    badge={notificationcount.notificationcount}
                />
                <HomeTile
                    to="/calendar"
                    tab={10}
                    icon="fa-calendar-days"
                    title="All your important dates in one location"
                    heading="Calendar"
                    description="All your important dates in one location"
                />
                {(examReg == 'true' || examReg == true) && (
                    <HomeTile
                        to="/myexam"
                        tab={8}
                        icon="fa-clipboard"
                        title="Your Exam Registrations"
                        heading="Exam Registration"
                        description="Your Exam Registrations"
                    />
                )}
                {(reReg == true || reReg == 'true') && (
                    <HomeTile
                        to="/reregistration"
                        tab={9}
                        icon="fa-file-pen"
                        title="Applications"
                        heading="Applications"
                        description="Your Applications"
                        badge={filesRequired == 1 ? 1 : 0}
                    />
                )}
                <HomeTile
                    to="/student-hub/"
                    tab={11}
                    icon="fa-circle-info"
                    title="Access academic resources, policies, library and how-to guides here"
                    heading="Student Hub"
                    description="Access academic resources, policies, library and how-to guides here"
                />
            </ul>
        </>
    );
};

export default HomeLinks;
